import { UseAxiosResult } from "axios-hooks";
import apiConfig from "../infrastructure/http/apiConfig";
import { useAxiosGet } from "../infrastructure/http/axios";
import { apimName } from "./common";
import { initialAppData } from "../components/Context/InitialAppDataContext.d";

const initialAppDataUrl = `${apiConfig.apimUrl}${apimName}/InitialAppData`;

export function useGetInitialAppData(manual?: boolean): UseAxiosResult<initialAppData, any> {
	return useAxiosGet<initialAppData>(initialAppDataUrl, manual ?? false);
}
